import { Button, Tooltip } from '@mantine/core';
import { ReactNode } from 'react';
import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks.tsx';

interface Props {
	canMutate: boolean;
	onClick: () => void;
	children: ReactNode;
}

export const ManageRequirementsButton = ({ canMutate, onClick, children }: Props) => {
	const tMipManage = useTranslationMipManage();

	const button = (
		<Button variant="default" onClick={onClick} disabled={!canMutate}>
			{children}
		</Button>
	);

	if (canMutate) {
		return button;
	}

	return (
		<Tooltip
			label={tMipManage('investment_details.frozen_tooltip', {
				defaultValue: 'This investment is completed and can no longer be edited',
			})}
		>
			<div>{button}</div>
		</Tooltip>
	);
};
